import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PurchaseOrderDetail from "@/components/inventory/purchase-orders/PurchaseOrderDetail";

const PurchaseOrderDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return (
    <div className="space-y-4">
      <Link
        to="/inventory/purchase-orders"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-card-foreground"
      >
        <ArrowLeft className="h-4 w-4" />
        Retour aux bons de commande
      </Link>
      <PurchaseOrderDetail uuid={id} />
    </div>
  );
};

export default PurchaseOrderDetailPage;
